import {
  Component,
  OnInit,
  Renderer2,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  OnDestroy,
  SecurityContext,
} from '@angular/core'
import { CheckoutService } from '../../checkout.service'
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  ValidatorFn,
  AbstractControl,
} from '@angular/forms'

import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { ChangeDetectorRef } from '@angular/core'
import { Subscription } from 'rxjs'
import { share, take } from 'rxjs/operators'
import { DomSanitizer } from '@angular/platform-browser'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { CommonService } from '../../../../../../shared/services/common.service'

@Component({
  standalone: false,
  selector: 'vs-notification-attachment',
  templateUrl: './notification-attachment.component.html',
  styleUrls: ['./notification-attachment.component.scss'],
})
export class NotificationAttachmentComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() getMethod: boolean
  @Output() updateFileData = new EventEmitter<any>()
  @Input() isProceedToCheckout: boolean
  @ViewChild('fileMaxLenghtExceednotify', { static: false })
  fileMaxLenghtExceednotify: ElementRef
  @ViewChild('fileTypeNotify', { static: false }) fileTypeNotify: ElementRef
  @ViewChild('fileSizeExceedNotify', { static: false })
  fileSizeExceedNotify: ElementRef
  @ViewChild('fileDuplicateNotify', { static: false })
  fileDuplicateNotify: ElementRef
  @ViewChild('fileInfoNotify', { static: false }) fileInfoNotify: ElementRef
  @ViewChild('filenameLengthNotify', { static: false })
  filenameLengthNotify: ElementRef
  @ViewChild('filenameSpecialcharNotify', { static: false })
  filenameSpecialcharNotify: ElementRef
  notifAttachObj: any = {
    orderAckEmail: '',
    invoiceEmail: '',
    shipNotificationEmail: '',
  }
  orderAckEmail: any = ''
  invoiceEmail: any = ''
  shipNotificationEmail: any = ''
  reasonForCsrReview: any = ''
  poDetails: any
  cartOrderReviewObj: any
  cartId: any
  cart: any
  fileClose: any
  fileUploadCheck = false
  showCheckbox
  @ViewChild('orderAckEmailError', { read: ElementRef, static: false })
  public orderAckEmailError: ElementRef
  /* Business requirement to remove invoiceEmail and shipNotificationEmail
  @ViewChild('invoiceEmailError', { read: ElementRef, static: false })
  public invoiceEmailError: ElementRef;
  @ViewChild('shipNotificationEmailError', { read: ElementRef, static: false })
  public shipNotificationEmailError: ElementRef;*/
  @ViewChild('reasonForCsrReviewError', { read: ElementRef, static: false })
  public reasonForCsrReviewError: ElementRef
  undefinedVar: any
  specialChar = /[`!@#$%^&*(){}.;,~]/

  constructor(
    private checkoutService: CheckoutService,
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    public activeCartService: ActiveCartFacade,
    private changeDetection: ChangeDetectorRef,
    private globalMessageService: GlobalMessageService,
    private domSanitizer: DomSanitizer
  ) {
    // this.csrReview = false;
    this.checkoutService.recieveCount.subscribe((data) => {
      if (data > 0) {
        this.showCheckbox = true
      } else {
        this.showCheckbox = false
      }
    })
  }

  defaultChoice: any
  public myFilesNotification: string[] = []
  public uploadedFiles: any[] = []
  public totalAllFiles: any = 0
  notificationAttachmentForm: FormGroup

  public csrReview: boolean
  public disbledBtn = false
  activeCartServiceSubscription: Subscription
  initialLoad: boolean = false

  ngOnDestroy(): void {
    if (this.activeCartServiceSubscription) {
      this.activeCartServiceSubscription.unsubscribe()
    }
  }

  ngOnInit(): void {
    this.notificationFormDetails()
    this.activeCartServiceSubscription = this.activeCartService
      .getActiveCartId()
      .subscribe(
        (cartId) => {
          this.initialLoad = true
          this.cartId = cartId
          this.checkoutService.getCartServerResponse.subscribe(
            (success) => {
              this.cartOrderReviewObj = success
              if (success['notificationDetails']) {
                /* Business requirement to remove invoiceEmail and shipNotificationEmail
                if (
                  success['notificationDetails']?.invoiceEmail !== undefined &&
                  success['notificationDetails']?.invoiceEmail !==
                    'undefined' &&
                  !success['notificationDetails']?.invoiceEmail.includes(
                    'undefined'
                  )
                ) {
                  this.notificationAttachmentForm.controls.invoiceEmail.setValue(
                    success['notificationDetails']?.invoiceEmail
                  );
                  this.invoiceEmail =
                    success['notificationDetails']?.invoiceEmail;
                  this.oninvoiceEmailUpdate(this.invoiceEmail);
                } */

                if (
                  success['notificationDetails']?.orderAckEmail !== undefined &&
                  success['notificationDetails']?.orderAckEmail !==
                    'undefined' &&
                  !success['notificationDetails']?.orderAckEmail.includes(
                    'undefined'
                  )
                ) {
                  this.notificationAttachmentForm.controls[
                    'orderAckEmail'
                  ].setValue(success['notificationDetails']?.orderAckEmail)
                  this.orderAckEmail =
                    success['notificationDetails']?.orderAckEmail
                  this.onorderAckEmail(this.orderAckEmail)
                }

                /* Business requirement to remove invoiceEmail and shipNotificationEmail
                if (
                  success['notificationDetails']?.shipNotificationEmail !==
                    undefined &&
                  success['notificationDetails']?.shipNotificationEmail !==
                    'undefined' &&
                  !success[
                    'notificationDetails'
                  ]?.shipNotificationEmail.includes('undefined')
                ) {
                  this.notificationAttachmentForm.controls.shipNotificationEmail.setValue(
                    success['notificationDetails']?.shipNotificationEmail
                  );
                  this.shipNotificationEmail =
                    success['notificationDetails']?.shipNotificationEmail;
                  this.onshipNotificationEmail(this.shipNotificationEmail);
                } */
                this.checkoutService.orderAckDataForm.next(
                  this.notificationAttachmentForm.valid
                )
              }
              if (success['isCsrReviewNeeded']) {
                this.csrReview = success['isCsrReviewNeeded']
                this.notificationAttachmentForm.controls[
                  'orderReview'
                ].setValue(success['isCsrReviewNeeded'])
                this.notificationAttachmentForm.controls[
                  'reasonForCsrReview'
                ].setValue(success['csrReviewReason'])
                this.checkoutService.reviewConditionData.next(
                  success['isCsrReviewNeeded']
                )
                if (success['csrReviewReason'] !== undefined) {
                  this.checkoutService.reasonForCsrReviewData.next(
                    success['csrReviewReason']
                  )
                } else {
                  this.checkoutService.reasonForCsrReviewData.next('')
                }
              }

              if (this.initialLoad) {
                this.checkoutService
                  .getDetailsForOrderNotifications(this.cartId)
                  .pipe(take(1), share())
                  .subscribe(
                    (response) => {
                      this.notifAttachObj = response
                      this.initialLoad = false
                      if (this.notifAttachObj.orderAckEmail) {
                        this.orderAckEmail = this.notifAttachObj.orderAckEmail
                        this.onorderAckEmail(this.orderAckEmail)
                      }
                      /* Business requirement to remove invoiceEmail and shipNotificationEmail
                      if (this.notifAttachObj.invoiceEmail) {
                        this.invoiceEmail = this.notifAttachObj.invoiceEmail;
                        this.oninvoiceEmailUpdate(this.invoiceEmail);
                      }
                      if (this.notifAttachObj.shipNotificationEmail) {
                        this.shipNotificationEmail = this.notifAttachObj.shipNotificationEmail;
                        this.onshipNotificationEmail(
                          this.shipNotificationEmail
                        );
                      } */

                      if (
                        this.cartOrderReviewObj['isCsrReviewNeeded'] !==
                        undefined
                      ) {
                        this.doOrderReview(
                          this.cartOrderReviewObj['isCsrReviewNeeded'],
                          this.cartOrderReviewObj['csrReviewReason']
                        )

                        this.checkoutService.reviewConditionData.next(
                          this.cartOrderReviewObj['isCsrReviewNeeded']
                        )

                        if (
                          this.cartOrderReviewObj['csrReviewReason'] !==
                          undefined
                        ) {
                          this.checkoutService.reasonForCsrReviewData.next(
                            this.cartOrderReviewObj['csrReviewReason']
                          )
                        } else {
                          this.checkoutService.reasonForCsrReviewData.next('')
                        }
                      } else {
                        this.doOrderReview(false, '')
                        this.checkoutService.reviewConditionData.next(false)
                      }

                      this.checkoutService.sendOrderAckdataForm(
                        this.notificationAttachmentForm.valid
                      )
                    },
                    (error) => {
                      this.initialLoad = false
                      this.globalMessageService.add(
                        error,
                        GlobalMessageType.MSG_TYPE_ERROR,
                        10000
                      )
                      window.scrollTo(0, 0)
                    }
                  )
              }
            },
            (error) => {
              this.globalMessageService.add(
                error,
                GlobalMessageType.MSG_TYPE_ERROR,
                10000
              )
              window.scrollTo(0, 0)
            }
          )
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )

    this.checkoutService.podetails.subscribe(
      (data) => {
        this.poDetails = data
        // this.orderAckEmail = this.poDetails.orderAckEmail;
        // this.notificationAttachmentForm.controls.orderAckEmail.setValue(this.poDetails.orderAckEmail);

        //this.invoiceEmail = this.poDetails.invoiceEmail;
        //this.shipNotificationEmail = this.poDetails.shipNotificationEmail;
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  convertFileRetain(data) {
    let returnVal
    returnVal = (data / (1024 * 1024)).toFixed(2)
    if (returnVal > 1) {
      return returnVal + 'mb'
    } else {
      return (data / 1024).toFixed(2) + 'kb'
    }
  }

  closeFile(event, mediaFile) {
    const urlparams = [
      'users',
      'current',
      'vscart',
      this.checkoutService.cartId,
      'removeAttachment',
    ]

    event.target.parentNode.innerHTML = ' '

    const apiUrl = this.commonService.constructUrl(urlparams)
    this.commonService
      .postData(apiUrl + '?' + 'mediaId=' + mediaFile, {})
      .subscribe((success) => {
        for (let i = 0; i < this.cartOrderReviewObj?.attachments.length; i++) {
          if (mediaFile === this.cartOrderReviewObj?.attachments[i].mediaCode) {
            // this.cart.attachments.splice(i, 1);
            this.cartOrderReviewObj.attachments.splice(i, 1)
            this.checkoutService.sendCartAttachments(
              this.cartOrderReviewObj.attachments
            )
            this.changeDetection.detectChanges()
          }
        }

        this.fileClose = success
      })

    // document.getElementById('hideFile').style.display = 'none';
  }

  ngOnChanges(changes: SimpleChanges): void {}
  get formControls() {
    return this.notificationAttachmentForm.controls
  }

  checkValidateTextAreaCsr() {
    if (this.csrReview) {
      if (
        this.notificationAttachmentForm.controls['reasonForCsrReview'] !==
          null &&
        this.notificationAttachmentForm.controls['reasonForCsrReview'].value !==
          null &&
        this.notificationAttachmentForm.controls['reasonForCsrReview'].value
          .length > 0
      ) {
      } else {
        this.checkoutService.orderAckDataForm.next(false)
      }
    }
  }

  csrTextAreaErrorConditionCheck() {
    if (
      this.notificationAttachmentForm.controls['reasonForCsrReview'] !== null &&
      this.notificationAttachmentForm.controls['reasonForCsrReview'] !==
        undefined &&
      this.notificationAttachmentForm.controls['reasonForCsrReview'].value !==
        null &&
      this.notificationAttachmentForm.controls['reasonForCsrReview'].value !==
        undefined &&
      this.notificationAttachmentForm.controls['reasonForCsrReview'].value
        .toString()
        .trim().length > 0
    ) {
      return false
    }
    return true
  }

  proceedToReview() {
    if (this.notificationAttachmentForm.invalid) {
      return
    }
  }

  onorderAckEmail(value: any) {
    this.checkoutService.onorderAckEmailData.next(value)
  }
  oninvoiceEmailUpdate(value: any) {
    this.checkoutService.oninvoiceEmailData.next(value)
  }
  onshipNotificationEmail(value: any) {
    this.checkoutService.onshipNotificationEmailData.next(value)
  }

  onreasonForCsrReview(value: any) {
    this.reasonForCsrReview = value
    this.checkoutService.reasonForCsrReviewData.next(value)
  }

  doOrderReview(value: any, reason) {
    this.notificationAttachmentForm.controls['reasonForCsrReview'].reset()
    this.notificationAttachmentForm.controls[
      'reasonForCsrReview'
    ].clearValidators()
    this.notificationAttachmentForm.controls[
      'reasonForCsrReview'
    ].updateValueAndValidity()
    if (value === 'true' || value === true) {
      this.csrReview = true
      if (reason !== undefined) {
        this.notificationAttachmentForm.controls['reasonForCsrReview'].setValue(
          reason
        )
      }
      this.checkoutService.reviewConditionData.next(true)
    } else {
      this.csrReview = false
      this.checkoutService.reasonForCsrReviewData.next('')
      this.checkoutService.reviewConditionData.next(false)
    }
    this.notificationAttachmentForm.controls[
      'reasonForCsrReview'
    ].clearValidators()
    this.notificationAttachmentForm.controls[
      'reasonForCsrReview'
    ].updateValueAndValidity()
    this.changeDetection.detectChanges()

    this.notificationAttachmentForm.controls[
      'reasonForCsrReview'
    ].valueChanges.subscribe(
      (data) => {
        this.checkoutService.reasonForCsrReviewData.next(data)
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  public emailFormat =
    '^([a-zA-Z0-9._%+-]+@(?!gmail.com|yahoo.com|hotmail.com)(?:[a-zA-Z0-9.-]+.?)(s*(,)s*|s*$))+$'

  notificationFormDetails() {
    this.notificationAttachmentForm = this.formBuilder.group({
      upload: new FormControl(''),
      orderAckEmail: new FormControl('', {
        updateOn: 'blur',
        validators: [Validators.required, Validators.pattern(this.emailFormat)],
      }),
      /* Business requirement to remove invoiceEmail and shipNotificationEmail   
      invoiceEmail: new FormControl('', {
        updateOn: 'blur',
        validators: [Validators.required, Validators.pattern(this.emailFormat)],
      }),
      shipNotificationEmail: new FormControl('', {
        updateOn: 'blur',
        validators: [Validators.required, Validators.pattern(this.emailFormat)],
      }), */

      orderReview: new FormControl('false', [Validators.required]),

      reasonForCsrReview: new FormControl('', {
        updateOn: 'blur',
        validators: [Validators.required],
      }),
    })

    this.notificationAttachmentForm.valueChanges.subscribe(
      (data) => {
        this.checkoutService.orderAckDataForm.next(
          !this.notificationAttachmentForm.invalid
        )
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  mailListValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null
      }
      var mailListArray = control.value.split(';')
      if (mailListArray.length > 0) {
        for (let i = 0; i < mailListArray.length; i++) {
          const regex = new RegExp(this.emailFormat)
          const valid = regex.test(mailListArray[i])
          const domainName = mailListArray[i].split('@').pop().split('.')[0]
          const secondEmailPart = mailListArray[i].split('@')[1]
          if (!valid) {
            return { invalidMail: true }
          } else if (
            domainName === undefined ||
            (domainName !== undefined && domainName.length === 0)
          ) {
            return { invalidMail: true }
          } else if (!mailListArray[i].split('@')[1].includes('.')) {
            return { invalidMail: true }
          } else if (
            secondEmailPart === undefined ||
            secondEmailPart.split('.')[1] === undefined ||
            (secondEmailPart.split('.')[1] !== undefined &&
              secondEmailPart.split('.')[1].length === 0)
          ) {
            return { invalidMail: true }
          }
        }
      }
      return null
    }
  }

  uploadNotifyFile(event) {
    const _this = this
    const filesTotal = 0
    let totalUploadedFiles = 0
    const totalFileSize = 0
    let prevFiles: any = 0

    this.fileMaxLenghtExceednotify.nativeElement.innerHTML = ''
    this.fileTypeNotify.nativeElement.innerHTML = ''
    this.fileSizeExceedNotify.nativeElement.innerHTML = ''
    this.fileDuplicateNotify.nativeElement.innerHTML = ''
    this.filenameLengthNotify.nativeElement.innerHTML = ''
    this.filenameSpecialcharNotify.nativeElement.innerHTML = ''
    const uploadDiv = this.domSanitizer.sanitize(
      SecurityContext.NONE,
      this.fileInfoNotify.nativeElement
    )

    const uploadedFilesCount = document.querySelectorAll(
      '.fileDivID-sectionnotify'
    )
    let isDuplicateFiles = false
    const allFileNames = []
    for (let j = 0; j < uploadedFilesCount.length; j++) {
      const size = parseInt(uploadedFilesCount[j].getAttribute('data-size'))
      allFileNames.push(uploadedFilesCount[j].getAttribute('data-filename'))
      prevFiles = prevFiles + size
    }
    let totalSize = prevFiles

    if (
      event.target.files.length <= 5 &&
      event.target.files.length + uploadedFilesCount.length <= 5
    ) {
      if (
        event.target.files.length === 5 ||
        event.target.files.length + uploadedFilesCount.length === 5
      ) {
        this.disbledBtn = true
      }

      for (let a = 0; a < event.target.files.length; a++) {
        totalSize += event.target.files[a].size
        allFileNames.forEach((file) => {
          if (event.target.files[a].name === file) {
            this.fileDuplicateNotify.nativeElement.innerHTML =
              'File Already exists'
            isDuplicateFiles = true
          }
        })
      }
      const filesMB = Math.round((totalSize / (1024 * 1024)) * 100) / 100 // in MB
      if (filesMB <= 30) {
        if (!isDuplicateFiles) {
          for (let i = 0; i < event.target.files.length; i++) {
            const res_field = event.target.files[i].name
            const extension = res_field
              .substr(res_field.lastIndexOf('.') + 1)
              .toLowerCase()
            const allowedExtensions = [
              'xlsx',
              'doc',
              'jpg',
              'png',
              'pdf',
              'jpeg',
            ]
            totalSize += event.target.files[i].size
            if (event.target.files[i].name.trim().length > 30) {
              this.filenameLengthNotify.nativeElement.innerHTML =
                'File name length should not be greater than 30 characters'
              return
            }
            let file_name = event.target.files[i].name.substring(
              0,
              event.target.files[i].name.lastIndexOf('.')
            )
            if (this.specialChar.test(file_name)) {
              this.filenameSpecialcharNotify.nativeElement.innerHTML =
                'File name should not contain any of the following special characters !@#$%^&*(){}.;,~'
              return
            }
            if (allowedExtensions.indexOf(extension) === -1) {
              this.fileTypeNotify.nativeElement.innerHTML =
                'File format is not supported'
              this.disbledBtn = false
            } else {
              this.uploadedFiles.push({
                filename: event.target.files[i].name,
                filesize: event.target.files[i].size,
              })

              const fileDivNotify = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('div')
              )
              this.renderer.appendChild(uploadDiv, fileDivNotify)
              this.renderer.setAttribute(fileDivNotify, 'id', 'fileDivID')
              this.renderer.setAttribute(
                fileDivNotify,
                'class',
                'fileDivIDUpload'
              )
              this.renderer.setAttribute(
                fileDivNotify,
                'data-size',
                event.target.files[i].size
              )
              this.renderer.setAttribute(
                fileDivNotify,
                'data-filename',
                event.target.files[i].name
              )
              this.renderer.addClass(fileDivNotify, 'fileDivID-sectionnotify')
              const fileIcon = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('i')
              )
              this.renderer.appendChild(fileDivNotify, fileIcon)
              this.renderer.addClass(fileIcon, 'material-icons')
              this.renderer.addClass(fileIcon, 'material-icons-custom')
              const iconText = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText('receipt')
              )
              this.renderer.appendChild(fileIcon, iconText)
              const fileName = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('p')
              )
              this.renderer.appendChild(fileDivNotify, fileName)
              this.renderer.setAttribute(fileName, 'id', 'para11')
              const fileNameText = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText(event.target.files[i].name)
              )
              this.renderer.appendChild(fileName, fileNameText)
              const fileSize = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('p')
              )
              this.renderer.appendChild(fileDivNotify, fileSize)
              this.renderer.setAttribute(fileSize, 'id', 'para22')
              const fileNameSize = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText(
                  // 'Size: ' + Math.round(event.target.files[i].size / 1024) + 'KB'
                  ' ' + this.getFileSize(event.target.files[i].size)
                )
              )
              this.renderer.appendChild(fileSize, fileNameSize)
              const closeIcon = this.renderer.createElement('span')
              this.renderer.appendChild(fileDivNotify, closeIcon)
              this.renderer.setAttribute(closeIcon, 'id', `${i}`)
              this.renderer.setAttribute(
                closeIcon,
                'data-name',
                event.target.files[i].name
              )
              this.renderer.addClass(closeIcon, 'closeId-img')
              const fileNameClose = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText('X')
              )
              this.renderer.appendChild(closeIcon, fileNameClose)
              closeIcon.addEventListener('click', function (evt) {
                _this.disbledBtn = false
                this.parentElement.remove()
                if (_this.fileMaxLenghtExceednotify != undefined) {
                  _this.fileMaxLenghtExceednotify.nativeElement.innerHTML = ' '
                }
                for (let z = 0; z < _this.myFilesNotification.length; z++) {
                  if (
                    this.getAttribute('data-name') ===
                    _this.uploadedFiles[z].filename
                  ) {
                    prevFiles = 0
                    _this.uploadedFiles.splice(z, 1)
                    totalUploadedFiles = totalUploadedFiles - 1
                    _this.myFilesNotification.splice(z, 1)
                    _this.updateFileData.emit(_this.myFilesNotification)
                  }
                }
              })
              this.myFilesNotification.push(event.target.files[i])
              this.updateFileData.emit(this.myFilesNotification)
              totalUploadedFiles = totalUploadedFiles + 1
            }
          } // for ends
        } else {
          this.disbledBtn = false
          this.fileDuplicateNotify.nativeElement.innerHTML =
            'File already exists'
        }
      } else {
        //  'file size exceeded';
        this.fileSizeExceedNotify.nativeElement.innerHTML =
          'File Size of all attachment should not exceed 30 MB'
        this.disbledBtn = false
      }
    } else {
      //  'You have exceeded files';
      this.fileMaxLenghtExceednotify.nativeElement.innerHTML =
        'You have exceeded files'
    }
    event.target.value = ''
  }
  getFileSize(fileSize) {
    if (Math.round((fileSize / 1024) * 1000) / 1000 >= 1024.0) {
      return (Math.round(fileSize / 1024) / 1024).toFixed(2) + ' mb'
    }
    if (Math.round((fileSize / 1024) * 1000) / 1000 < 1024.0) {
      return (Math.round((fileSize / 1024) * 1000) / 1000).toFixed(2) + ' kb'
    }
  }
  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field)
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true })
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control)
      }
    })
  }
  getCheckBoxStatus() {
    this.fileUploadCheck = !this.fileUploadCheck
    this.checkoutService.sendCheckboxFlag(this.fileUploadCheck)
  }
}
